<div class="bg-surface-0 dark:bg-surface-900 border border-surface-200 dark:border-surface-800 rounded-xl p-3 mb-6 shadow-sm">
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <nav class="flex items-center flex-wrap gap-1 text-sm text-surface-500 dark:text-surface-400">
            <ng-container *ngFor="let breadcrumb of getBreadcrumbPath(); let isLast = last">
                <div class="flex items-center">
                    <!-- Home -->
                    <button
                        *ngIf="isListingRoot(breadcrumb.id)"
                        (click)="!isLast && navigateToBreadcrumb(breadcrumb)"
                        [pTooltip]="'Ir para o início'"
                        class="flex items-center justify-center text-surface-500 dark:text-surface-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                        [disabled]="isLast"
                    >
                        <i class="pi pi-home text-sm"></i>
                    </button>

                    <!-- Diretório -->
                    <span
                        *ngIf="!isListingRoot(breadcrumb.id)"
                        (click)="!isLast && navigateToBreadcrumb(breadcrumb)"
                        class="cursor-pointer whitespace-nowrap max-w-[220px] truncate transition-colors"
                        [ngClass]="isLast ? 'text-surface-900 dark:text-surface-100 font-semibold' : 'hover:text-primary-600 dark:hover:text-primary-400'"
                        title="{{ breadcrumb.name }}"
                    >
                        {{ breadcrumb.name.toUpperCase() }}
                    </span>

                    <!-- Separador -->
                    <i *ngIf="!isLast" class="pi pi-chevron-right mx-2 text-[9px] text-surface-300 dark:text-surface-600"></i>
                </div>
            </ng-container>
        </nav>

        <div class="flex items-center gap-4 px-2 py-1 bg-surface-50 dark:bg-surface-800 rounded-lg border border-surface-100 dark:border-surface-700">
            <div class="flex items-center gap-1.5 text-sm text-surface-500">
                <i class="pi pi-folder text-amber-500"></i>
                <span class="font-semibold text-surface-700 dark:text-surface-200">{{ shareds$().length }}</span>
                Diretórios
            </div>
            <div class="h-3 w-[1px] bg-surface-300"></div>
            <div class="flex items-center gap-1.5 text-sm text-surface-500">
                <i class="pi pi-file text-ambar-500"></i>
                <span class="font-semibold text-surface-700 dark:text-surface-200">{{ filesTotalRecords }}</span>
                Arquivos
            </div>
        </div>
    </div>
</div>

<div class="flex flex-wrap items-center justify-between gap-4 mb-6 sticky top-0 z-10 bg-surface-background/80 backdrop-blur-md py-2">
    <div class="flex p-1 bg-surface-100 dark:bg-surface-800 rounded-xl">
        <button
            (click)="toggleView(ViewMode.GRID)"
            [ngClass]="viewMode === ViewMode.GRID ? 'bg-white dark:bg-surface-900 shadow-sm text-primary-500' : 'text-surface-500'"
            class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all"
        >
            <i class="pi pi-th-large"></i> Grade
        </button>
        <button
            (click)="toggleView(ViewMode.LIST)"
            [ngClass]="viewMode === ViewMode.LIST ? 'bg-white dark:bg-surface-900 shadow-sm text-primary-500' : 'text-surface-500'"
            class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all"
        >
            <i class="pi pi-list"></i> Lista
        </button>
    </div>

    <div class="flex items-center gap-2">
        <p-button *ngIf="selectedDirectoryId" icon="pi pi-arrow-left" [rounded]="true" [text]="true" (click)="goBack()" pTooltip="Voltar"></p-button>

        <p-button icon="pi pi-refresh" severity="success" [rounded]="true" [text]="true" [loading]="isLoading" (click)="loadShareds({ first: 0, rows: 10 })" pTooltip="Sincronizar"></p-button>

        <p-divider layout="vertical" class="hidden sm:block"></p-divider>

        <p-button *ngIf="selectedDirectoryId" label="Novo" icon="pi pi-plus" severity="success" [outlined]="true" (click)="createMenu.toggle($event)"></p-button>
        <p-menu #createMenu [popup]="true" [model]="createMenuItems" appendTo="body"></p-menu>

        <p-button *ngIf="selectedDirectoryId" label="Upload" icon="pi pi-upload" (click)="triggerFileSelect()" class="shadow-sm"></p-button>

        <input #fileInput type="file" (change)="onUploadSelectedFiles($event)" multiple hidden />
    </div>
</div>

<div class="min-h-[400px]">
    <div *ngIf="isLoading; else contentLoaded" class="flex flex-col justify-center items-center py-20 gap-4">
        <p-progressSpinner styleClass="w-12 h-12" strokeWidth="4"></p-progressSpinner>
        <span class="text-surface-500 animate-pulse">Carregando diretórios...</span>
    </div>

    <ng-template #contentLoaded>
        <section class="mb-4">
            <!-- Header mais baixo e direto -->
            <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 pb-3 border-b border-surface-100 dark:border-surface-800 gap-4">
                <div class="flex items-center gap-3">
                    <!-- Ícone menor -->
                    <div class="flex items-center justify-center min-w-[40px] h-10">
                        <i class="pi pi-folder" style="font-size: 1.2rem; color: #fbbf24"></i>
                    </div>

                    <div class="flex flex-col">
                        <div class="flex items-center gap-3">
                            <h3 class="text-xl font-bold tracking-tight text-surface-900 dark:text-surface-0">Diretórios</h3>

                            <!-- Badge mais discreta -->
                            <div class="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-surface-100 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
                                <span class="relative flex h-1.5 w-1.5">
                                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                                    <span class="relative inline-flex rounded-full h-1.5 w-1.5 bg-amber-500"></span>
                                </span>
                                <span class="text-[10px] font-bold font-mono text-surface-700 dark:text-surface-300">
                                    {{ shareds$().length | number: '2.0-0' }}
                                </span>
                            </div>
                        </div>
                        <!-- Subtexto menor e menos espaçado -->
                        <p class="text-xs text-surface-500 dark:text-surface-400 max-w-xl">Gerencie suas pastas seguras.</p>
                    </div>
                </div>
            </div>

            <!-- Container de Loading -->
            <div *ngIf="isLoading; else directoriesLoaded" class="flex justify-center py-6">
                <p-progressSpinner styleClass="w-8 h-8"></p-progressSpinner>
            </div>

            <!-- Lista e Paginador -->
            <ng-template #directoriesLoaded>
                <app-directory-list
                    [directories]="shareds$()"
                    [viewMode]="viewMode"
                    (directorySelected)="onDirectorySelect($event)"
                    [currentDirectory]="selectedDirectory"
                    (createSubdirectory)="onCreateSubdirectoryFromContext($event)"
                    (deleteDirectory)="onMoveDirectoryToRecycle($event)"
                    (renameDirectorySelected)="onRenameDirectorySelected($event)"
                    (moveToDirectory)="onMoveDirectorySelected($event)"
                    (uploadFileToDirectory)="onUploadFileToDirectory($event)"
                    (droppedFilesIntoDirectory)="onUploadSelectedDirectory($event)"
                    (directoryProperties)="openDirectoryProperties($event)"
                >
                </app-directory-list>

                <!-- Paginador com margem reduzida -->
                <div class="mt-4">
                    <p-paginator
                        *ngIf="shareds$().length > 0 && shareds$()[0]?.parentId != null"
                        [first]="first"
                        [rows]="rows"
                        [totalRecords]="totalRecords"
                        [showCurrentPageReport]="true"
                        (onPageChange)="loadShareds($event)"
                        currentPageReportTemplate="{first}-{last} de {totalRecords}"
                        [rowsPerPageOptions]="[10, 20, 50, 100]"
                        class="opacity-70 hover:opacity-100 transition-opacity"
                    ></p-paginator>
                </div>
            </ng-template>
        </section>

        <section *ngIf="selectedDirectoryId" class="pt-6 border-surface-100 dark:border-surface-800">
            <div class="flex flex-col md:flex-row md:items-end justify-between mb-10 pb-6 border-b border-surface-100 dark:border-surface-800 gap-6 mt-12">
                <div class="flex items-start gap-5">
                    <div class="flex items-center justify-center min-w-[64px] h-16 text-blue-600 dark:text-blue-400">
                        <i class="pi pi-file" style="font-size: 2rem"></i>
                    </div>

                    <div class="flex flex-col gap-1">
                        <div class="flex items-center gap-4">
                            <h3 class="text-2xl font-black tracking-tight text-surface-900 dark:text-surface-0">Arquivos</h3>

                            <div class="flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/50">
                                <span class="relative flex h-2 w-2">
                                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                                    <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                                </span>
                                <span class="text-xs font-bold font-mono text-blue-700 dark:text-blue-300">
                                    {{ filesTotalRecords | number: '2.0-0' }}
                                </span>
                            </div>
                        </div>

                        <p class="text-base text-surface-500 dark:text-surface-400 max-w-md leading-relaxed">Visualize, baixe e gerencie todos os documentos deste diretório.</p>
                    </div>
                </div>

                <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div class="flex flex-wrap items-center gap-3">
                        <button
                            pButton
                            type="button"
                            label="Selecionar todos"
                            icon="pi pi-check-square"
                            class="p-button-secondary font-bold"
                            (click)="selectAllFiles()"
                            [disabled]="files$.length === 0 || isAllFilesSelected"
                        ></button>

                        <button
                            pButton
                            type="button"
                            label="Limpar seleção"
                            icon="pi pi-times"
                            class="p-button-text font-bold"
                            (click)="clearSelectedFiles()"
                            [disabled]="selectedFiles.length === 0"
                        ></button>

                        <button
                            pButton
                            type="button"
                            label="Excluir selecionados"
                            icon="pi pi-trash"
                            class="p-button-danger p-button-text font-bold"
                            (click)="bulkDeleteSelectedFiles()"
                            [disabled]="selectedFiles.length === 0"
                        ></button>

                        <span class="text-sm text-surface-600 dark:text-surface-400">
                            <b *ngIf="selectedFiles.length > 0" >{{ selectedFiles.length }} arquivo(s) selecionado(s)</b>
                        </span>
                    </div>

                    <div class="text-right hidden lg:block border-l border-surface-200 dark:border-surface-800 pl-6">
                        <p class="text-[10px] uppercase tracking-[0.2em] font-bold text-surface-400 mb-1">Total em Disco</p>
                        <div class="flex items-center gap-2 text-surface-700 dark:text-surface-200">
                            <i class="pi pi-database text-blue-500 text-xs"></i>
                            <span class="text-sm font-bold">{{ totalSizeFormatted() }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="isLoadingFiles; else filesLoaded" class="flex justify-center py-10">
                <p-progressSpinner styleClass="w-10 h-10"></p-progressSpinner>
            </div>

            <ng-template #filesLoaded>
                <app-file-list
                    [files]="files$"
                    [viewMode]="viewMode"
                    [selectedFiles]="selectedFiles"
                    (selectedFilesChange)="onSelectedFilesChange($event)"
                    (fileSelected)="onFileSelect($event)"
                    (renameFileConfirmed)="onRenameFileSelected($event)"
                    (moveFile)="onMoveFileSelected($event)"
                    (downloadFile)="onDownloadFile($event)"
                    (deleteFile)="onMoveFileToRecycle($event)"
                    (fileProperties)="openFileProperties($event)"
                >
                </app-file-list>

                <div class="mt-8 pt-4">
                    <p-paginator
                        *ngIf="files$.length > 0"
                        [first]="filesFirst"
                        [rows]="filesRows"
                        [totalRecords]="filesTotalRecords"
                        [showCurrentPageReport]="true"
                        (onPageChange)="loadFiles($event)"
                        currentPageReportTemplate="Exibindo {first} - {last} de {totalRecords} itens"
                        [rowsPerPageOptions]="[10, 20, 50, 100]"
                        styleClass="mt-10 block border-t border-surface-50 dark:border-surface-800 pt-6"
                    >
                    </p-paginator>
                </div>
            </ng-template>
        </section>
    </ng-template>
</div>

<!-- Dialog de movimentação -->
<p-dialog [(visible)]="moveDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false" [style]="{ width: '560px' }" styleClass="rounded-xl overflow-hidden">
    <ng-template pTemplate="header">
        <div class="flex items-center gap-3">
            <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-violet-100 dark:bg-violet-900/30 text-violet-600 dark:text-violet-300">
                <i class="pi pi-arrow-right-arrow-left"></i>
            </div>
            <div class="flex flex-col">
                <span class="text-base font-semibold">Mover {{ moveTargetType === 'directory' ? 'diretório' : 'arquivo' }}</span>
                <span class="text-xs text-surface-500 dark:text-surface-400">Escolha a pasta de destino</span>
            </div>
        </div>
    </ng-template>

    <div class="space-y-4">
        <div class="rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-800/60 p-3">
            <div class="text-[11px] uppercase tracking-[0.2em] text-surface-500 dark:text-surface-400 mb-1">Origem</div>
            <div class="font-semibold text-surface-900 dark:text-surface-0">{{ moveTargetItem?.name }}</div>
            <div class="text-xs text-surface-500 dark:text-surface-400 mt-1">Navegue até a pasta desejada e confirme o destino.</div>
        </div>

        <div class="flex flex-wrap items-center gap-2">
            <ng-container *ngFor="let crumb of moveBreadcrumb; let i = index; let isLast = last">
                <button
                    type="button"
                    class="px-2.5 py-1.5 rounded-full border text-sm transition-all"
                    [ngClass]="i === moveBreadcrumb.length - 1
                        ? 'border-primary-500 bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300'
                        : 'border-surface-200 dark:border-surface-700 bg-white dark:bg-surface-900 text-surface-600 dark:text-surface-300 hover:border-primary-300'"
                    (click)="navigateMoveBreadcrumb(i)"
                    [disabled]="isLast"
                >
                    {{ crumb.name }}
                </button>
                <i *ngIf="!isLast" class="pi pi-chevron-right text-[10px] text-surface-400"></i>
            </ng-container>
        </div>

        <div class="min-h-[220px] rounded-xl border border-surface-200 dark:border-surface-700 bg-white dark:bg-surface-900/70 p-3">
            <div *ngIf="moveBrowsingLoading" class="flex items-center justify-center h-full py-10 text-surface-500">
                <i class="pi pi-spin pi-spinner mr-2"></i>
                Carregando pastas...
            </div>

            <div *ngIf="!moveBrowsingLoading && moveBrowsingDirectories.length === 0" class="flex flex-col items-center justify-center h-full py-10 text-surface-500">
                <i class="pi pi-folder-open text-3xl mb-2"></i>
                <span>Nenhuma subpasta encontrada aqui.</span>
            </div>

            <div *ngIf="!moveBrowsingLoading && moveBrowsingDirectories.length > 0" class="flex flex-col gap-2">
                <div
                    *ngFor="let directory of moveBrowsingDirectories"
                    class="flex items-center justify-between gap-3 rounded-lg border border-surface-200 dark:border-surface-700 p-3 bg-surface-50 dark:bg-surface-800/60"
                >
                    <button type="button" class="flex items-center gap-3 text-left flex-1" (click)="openMoveDirectory(directory)">
                        <div class="flex items-center justify-center w-9 h-9 rounded-lg bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-300">
                            <i class="pi pi-folder"></i>
                        </div>
                        <div>
                            <div class="font-medium text-surface-900 dark:text-surface-0">{{ directory.name }}</div>
                            <div class="text-xs text-surface-500 dark:text-surface-400">Abrir pasta</div>
                        </div>
                    </button>

                    <p-button
                        label="Selecionar"
                        severity="secondary"
                        [text]="true"
                        [disabled]="moveTargetItem?.id === directory.id"
                        (click)="selectMoveDestination(directory)"
                    ></p-button>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex items-center justify-between gap-3 w-full">
            <span class="text-sm text-surface-500 dark:text-surface-400">Destino: {{ moveDestinationName }}</span>
            <div class="flex gap-2">
                <p-button label="Cancelar" [text]="true" severity="secondary" (click)="closeMoveDialog()"></p-button>
                <p-button label="Mover aqui" severity="success" [disabled]="!moveDestinationId" (click)="confirmMove()"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="newDocumentDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(560px, calc(100vw - 2rem))' }"
    styleClass="rounded-xl overflow-hidden"
>
    <ng-template pTemplate="header">
        <div>
            <h2 class="m-0 text-xl font-semibold text-surface-900 dark:text-surface-0">Novo documento</h2>
            <p class="m-0 mt-1 text-sm text-surface-500 dark:text-surface-400">Crie um novo arquivo para começar a editar.</p>
        </div>
    </ng-template>

    <div class="flex flex-col gap-5">
        <section class="rounded-lg border border-surface-200 dark:border-surface-700 p-3 sm:p-4">
            <h3 class="m-0 mb-3 text-sm font-semibold text-surface-800 dark:text-surface-100">Tipo de documento</h3>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                <button
                    *ngFor="let type of documentTypes"
                    type="button"
                    class="flex items-start gap-3 rounded-lg border p-3 text-left transition-colors"
                    [ngClass]="selectedDocumentType.id === type.id
                        ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20 ring-1 ring-primary-500/30'
                        : 'border-surface-200 dark:border-surface-700 hover:border-surface-400 dark:hover:border-surface-500'"
                    (click)="selectedDocumentType = type"
                >
                    <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-md"
                        [ngClass]="type.color === 'blue' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300'
                            : type.color === 'green' ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300'
                            : 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300'">
                        <i [class]="type.icon + ' text-lg'"></i>
                    </span>
                    <span class="flex min-w-0 flex-col">
                        <span class="text-sm font-semibold text-surface-900 dark:text-surface-0">{{ type.label }}</span>
                        <span class="text-xs text-surface-500 dark:text-surface-400">{{ type.application }}</span>
                        <span class="mt-1 text-xs uppercase text-surface-500 dark:text-surface-400">{{ type.extension }}</span>
                    </span>
                </button>
            </div>
        </section>

        <div class="flex flex-col gap-2">
            <label for="newDocumentName" class="text-sm font-medium text-surface-800 dark:text-surface-100">Nome do arquivo</label>
            <input
                pInputText
                id="newDocumentName"
                [(ngModel)]="newDocumentName"
                class="w-full"
                maxlength="120"
                autocomplete="off"
                (keydown.enter)="createNewDocument()"
            />
        </div>

        <div class="flex flex-col gap-2">
            <span class="text-sm font-medium text-surface-800 dark:text-surface-100">Localização</span>
            <div class="flex min-w-0 items-center gap-2 text-sm text-surface-600 dark:text-surface-300">
                <i class="pi pi-folder shrink-0"></i>
                <span class="truncate" [title]="getCurrentDirectoryPath()">
                    {{ getCurrentDirectoryPath().replaceAll('/', ' / ') }}
                </span>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancelar" severity="secondary" [outlined]="true" [disabled]="isCreatingDocument" (click)="newDocumentDialog = false"></p-button>
            <p-button label="Criar" icon="pi pi-check" [loading]="isCreatingDocument" [disabled]="!newDocumentName.trim()" (click)="createNewDocument()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Dialog de Upload -->
<p-dialog [(visible)]="uploading" [modal]="true" [closable]="false" [style]="{ width: '450px' }" styleClass="upload-dialog-modern">
    <ng-template pTemplate="header">
        <div class="flex flex-col gap-1">
            <h3 class="text-base font-bold m-0">
                {{ isFolderUpload ? 'A enviar pastas...' : 'A enviar ficheiros...' }}
            </h3>
            <span class="text-xs text-surface-500"> {{ completedUploadsCount }} de {{ uploadProgress.length }} concluídos </span>
        </div>
    </ng-template>

    <div class="flex flex-col gap-3 mt-2">
        <p-progressBar [value]="totalProgress" [showValue]="true" styleClass="h-2"></p-progressBar>

        <div class="max-h-60 overflow-y-auto pr-2 flex flex-col gap-2">
            <div *ngFor="let file of uploadProgress" class="flex items-center justify-between p-2 rounded bg-surface-50 dark:bg-surface-900/50 border border-surface-100 dark:border-surface-800">
                <div class="flex items-center gap-2 overflow-hidden">
                    <i [class]="file.error ? 'pi pi-times-circle text-red-500' : 'pi pi-file text-blue-500'" class="text-xs"></i>
                    <span class="text-[11px] truncate w-64" [title]="file.name">{{ file.name }}</span>
                </div>
                <i *ngIf="file.progress === 100 && !file.error" class="pi pi-check text-green-500 text-xs"></i>
                <span *ngIf="file.error" class="text-[10px] text-red-500 font-bold">Erro</span>
            </div>
        </div>
    </div>
</p-dialog>

<!-- Dialog de propriedades do diretório -->
<p-dialog [(visible)]="dirPropsDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false" [style]="{ width: '460px' }" styleClass="rounded-xl overflow-hidden">
    <!-- Header custom -->
    <ng-template pTemplate="header">
        <div class="flex items-center gap-3">
            <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-amber-100 dark:bg-amber-900/30">
                <i class="pi pi-folder text-amber-600 dark:text-amber-300"></i>
            </div>
            <div class="flex flex-col">
                <span class="text-base font-semibold"> Propriedades do Diretório </span>
                <span class="text-xs text-surface-500 dark:text-surface-400"> Informações gerais </span>
            </div>
        </div>
    </ng-template>

    <!-- Conteúdo -->
    <div *ngIf="dirPropsTarget" class="space-y-4 text-sm text-surface-700 dark:text-surface-200">
        <!-- Nome -->
        <div class="p-3 rounded-lg bg-surface-100 dark:bg-surface-800">
            <div class="text-xs text-surface-500 dark:text-surface-400 mb-1">Nome</div>
            <div class="font-medium truncate">
                {{ dirPropsTarget.name }}
            </div>
        </div>

        <!-- Grid de infos -->
        <div class="grid grid-cols-2 gap-3">
            <div class="p-3 rounded-lg bg-surface-100 dark:bg-surface-800">
                <div class="text-xs text-surface-500 dark:text-surface-400 mb-1">ID</div>
                <div class="font-mono text-xs truncate">
                    {{ dirPropsTarget.id }}
                </div>
            </div>

            <div class="p-3 rounded-lg bg-surface-100 dark:bg-surface-800">
                <div class="text-xs text-surface-500 dark:text-surface-400 mb-1">Compartilhável</div>
                <div class="flex items-center gap-2 font-medium">
                    <i class="pi" [ngClass]="dirPropsTarget.shareable ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-400'"> </i>
                    {{ dirPropsTarget.shareable ? 'Sim' : 'Não' }}
                </div>
            </div>
        </div>

        <!-- Parent -->
        <div class="p-3 rounded-lg bg-surface-100 dark:bg-surface-800">
            <div class="text-xs text-surface-500 dark:text-surface-400 mb-1">Diretório pai</div>
            <div class="font-mono text-xs truncate">
                {{ !dirPropsTarget.parentId ? 'Raiz' : getParentDirectoryName() }}
            </div>
        </div>

        <!-- Hint -->
        <div class="text-xs text-surface-500 dark:text-surface-400 italic">Estatísticas detalhadas em desenvolvimento.</div>
    </div>

    <!-- Footer -->
    <ng-template pTemplate="footer">
        <div class="flex justify-end">
            <p-button label="Fechar" icon="pi pi-times" severity="secondary" [text]="true" (click)="dirPropsDialog = false"> </p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Dialog de propriedades do arquivo -->
<p-dialog [(visible)]="filePropsDialog" [modal]="true" [style]="{ width: '440px' }" styleClass="p-fluid rounded-2xl shadow-2xl">
    <ng-template pTemplate="header">
        <div class="flex items-center gap-4">
            <div class="p-3 bg-blue-50 dark:bg-blue-900/30 rounded-xl text-blue-600">
                <i class="pi pi-file text-xl"></i>
            </div>
            <div>
                <h4 class="m-0 font-bold text-lg">Detalhes do Arquivo</h4>
                <p class="m-0 text-xs text-surface-500">Informações técnicas e metadados</p>
            </div>
        </div>
    </ng-template>

    <div *ngIf="filePropsTarget" class="flex flex-col gap-4 mt-2">
        <div class="p-4 bg-surface-50 dark:bg-surface-800 rounded-xl border border-surface-100 dark:border-surface-700">
            <label class="text-[10px] uppercase tracking-wider font-bold text-surface-400">Nome do arquivo</label>
            <div class="text-surface-900 dark:text-surface-50 font-medium break-all mt-1">{{ filePropsTarget.name }}</div>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <div class="p-3 bg-surface-50 dark:bg-surface-800 rounded-xl border border-surface-100 dark:border-surface-700">
                <label class="text-[10px] uppercase font-bold text-surface-400">Tamanho</label>
                <div class="font-semibold mt-1">{{ filePropsTarget.contentLength | number }} KB</div>
            </div>
            <div class="p-3 bg-surface-50 dark:bg-surface-800 rounded-xl border border-surface-100 dark:border-surface-700">
                <label class="text-[10px] uppercase font-bold text-surface-400">Tipo</label>
                <div class="font-semibold mt-1 flex items-center gap-2">
                    <i class="material-icons text-[22px]" 
                    [ngClass]="getFileTypeColor(filePropsTarget.contentType)">
                        {{ getFileIcon(filePropsTarget.contentType) }}
                    </i>
                    {{ getFileTypeLabel(filePropsTarget.contentType) }}
                </div>
            </div>
        </div>

        <div class="p-3 bg-surface-50 dark:bg-surface-800 rounded-xl border border-surface-100 dark:border-surface-700 grid grid-cols-1 gap-3">
            <div>
                <label class="text-[10px] uppercase font-bold text-surface-400 block mb-1">Criação</label>
                <div class="flex justify-between items-center text-xs">
                    <span class="text-surface-700 dark:text-surface-200 font-medium">{{ filePropsTarget.createdBy.name || 'Sistema' }}</span>
                    <span class="text-surface-500">{{ filePropsTarget.createdAt | date: 'dd/MM/yyyy HH:mm' : '-0300' }}</span>
                </div>
            </div>

            <div class="border-t border-surface-200 dark:border-surface-700 pt-2" *ngIf="filePropsTarget.updatedBy">
                <label class="text-[10px] uppercase font-bold text-surface-400 block mb-1">Última Modificação</label>
                <div class="flex justify-between items-center text-xs">
                    <span class="text-surface-700 dark:text-surface-200 font-medium">{{ filePropsTarget.updatedBy.name }}</span>
                    <span class="text-surface-500">{{ filePropsTarget.lastModified | date: 'dd/MM/yyyy HH:mm' : '-0300' }}</span>
                </div>
            </div>
        </div>

        <div class="p-3 bg-surface-50 dark:bg-surface-800 rounded-xl border border-surface-100 dark:border-surface-700">
            <label class="text-[10px] uppercase font-bold text-surface-400">ID Único</label>
            <div class="font-mono text-[10px] mt-1 text-surface-500 select-all">{{ filePropsTarget.id }}</div>
        </div>
    </div>
</p-dialog>

<!-- Dialog de visualização de imagens -->
<p-dialog
    [(visible)]="displayImageModal"
    [modal]="true"
    [maximizable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '70vw', maxWidth: '1100px' }"
    [contentStyle]="{ padding: '0', overflow: 'hidden', display: 'flex', 'flex-direction': 'column' }"
    styleClass="custom-image-dialog"
    (onHide)="imageBase64DataUrl = null"
>
    <ng-template pTemplate="header">
        <div class="flex items-center justify-between w-full pr-8">
            <div class="flex items-center gap-3">
                <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 dark:bg-purple-900/30 text-purple-500">
                    <i class="pi pi-image text-xl"></i>
                </div>
                <div class="flex flex-col">
                    <span class="text-[10px] font-bold uppercase tracking-widest text-surface-400 leading-none mb-1"> Visualizador </span>
                    <h3 class="text-base font-semibold text-surface-900 dark:text-surface-0 m-0 leading-tight">
                        {{ imageName }}
                    </h3>
                </div>
            </div>

            <button pButton icon="pi pi-download" label="Baixar" class="p-button-rounded p-button-outlined p-button-sm ml-auto" (click)="downloadImage()"></button>
        </div>
    </ng-template>

    <div class="image-viewer-container flex-grow flex items-center justify-center bg-surface-950 relative">
        <div class="absolute inset-0 opacity-10 pointer-events-none" [style.background-image]="'url(' + imageBase64DataUrl + ')'" style="background-size: cover; background-position: center; filter: blur(40px)"></div>

        <ng-container *ngIf="imageBase64DataUrl">
            <img [src]="imageBase64DataUrl" class="main-image shadow-2xl transition-all duration-300" alt="Preview" />
        </ng-container>

        <div *ngIf="!imageBase64DataUrl" class="flex flex-col items-center gap-3 z-10">
            <p-progressSpinner styleClass="w-10 h-10" strokeWidth="4"></p-progressSpinner>
            <span class="text-surface-400 text-sm">Carregando...</span>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-center w-full py-2">
            <span class="text-[11px] text-surface-500 uppercase tracking-tighter"> Use o ícone de tela cheia no topo para ampliar </span>
        </div>
    </ng-template>
</p-dialog>

<!-- Dialog para visualização de arquivo de texto -->
<p-dialog [(visible)]="displayTextViewer" [modal]="true" [maximizable]="true" [style]="{ width: '75vw' }" styleClass="custom-editor-dialog">
    <ng-template pTemplate="header">
        <div class="flex items-center gap-3">
            <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-500">
                <i class="pi pi-file-edit text-xl"></i>
            </div>

            <div class="flex flex-col">
                <span class="text-xs font-bold uppercase tracking-widest text-surface-400 leading-none mb-1"> Editor de Texto </span>
                <h3 class="text-base font-semibold text-surface-900 dark:text-surface-0 m-0 leading-tight">
                    {{ fileName }}
                </h3>
            </div>

            <p-badge value="UTF-8" severity="info" styleClass="ml-2 text-[10px]"></p-badge>
        </div>
    </ng-template>

    <p-editor [(ngModel)]="fileContent" [style]="{ height: '60vh' }"></p-editor>

    <ng-template pTemplate="footer">
        <button pButton label="Fechar" class="p-button-text" (click)="displayTextViewer = false"></button>
        <button pButton label="Salvar Arquivo (Em desenvolvimento)" icon="pi pi-save" disabled></button>
    </ng-template>
</p-dialog>

<!-- Dialog para criação de diretório -->
<app-directory-dialog [(visible)]="directoryDialog" [directoryForm]="directoryForm" [isEditMode]="isEditMode" (save)="saveDirectory($event)" (cancel)="cancelDirectory()"> </app-directory-dialog>

<!-- Dialog de confirmação -->
<p-confirmDialog>
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-950 rounded-3xl border border-surface-100 dark:border-surface-800 shadow-2xl">
            <div class="w-20 h-20 bg-rose-50 dark:bg-rose-500/10 rounded-full flex items-center justify-center mb-6">
                <i class="pi pi-trash text-rose-500 text-4xl"></i>
            </div>

            <h2 class="text-2xl font-black text-surface-900 dark:text-surface-0 m-0 mb-2">
                {{ message.header }}
            </h2>

            <p class="text-surface-500 dark:text-surface-400 text-center mb-8" [innerHTML]="message.message"></p>

            <div class="flex gap-3 w-full">
                <button (click)="message.reject()" class="flex-1 px-6 py-3 font-bold text-surface-600 dark:text-surface-300 hover:bg-surface-100 dark:hover:bg-surface-800 rounded-2xl transition-all border-none bg-transparent outline-none">
                    {{ message.rejectLabel }}
                </button>

                <button (click)="message.accept()" class="flex-1 px-6 py-3 font-bold bg-rose-500 hover:bg-rose-600 text-white shadow-lg shadow-rose-500/30 rounded-2xl transition-all border-none outline-none">
                    {{ message.acceptLabel }}
                </button>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>

<p-toast>
    <ng-template let-message pTemplate="message">
        <div class="toast-copy">
            <strong>{{ message.summary }}</strong>
            <div class="font-semibold mt-1">{{ message.detail }}</div>
        </div>
    </ng-template>
</p-toast>
